import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface OrderBumpModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPack: 'basic' | 'pro';
}
export function OrderBumpModal({
  isOpen,
  onClose,
  selectedPack
}: OrderBumpModalProps) {
  const [isBumpSelected, setIsBumpSelected] = useState(true);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const packPrice = selectedPack === 'basic' ? 19999 : 27999;
  const bumpPrice = 5999;
  const totalPrice = isBumpSelected ? packPrice + bumpPrice : packPrice;
  const packName = selectedPack === 'basic' ? 'MegaPack Salir del Veraz' : 'MegaPack + Retribución';
  const getCheckoutUrl = () => {
    const packId = selectedPack === 'basic' ? '42769535696994:1' : '42769545560162:1';
    const bumpId = '42830744092770:1';
    if (isBumpSelected) {
      return `https://checkout.infinita-mente.online/cart/${packId},${bumpId}`;
    }
    return `https://checkout.infinita-mente.online/cart/${packId}`;
  };
  return <AnimatePresence data-id="element-167">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-168">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-169" />

          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        duration: 0.5,
        bounce: 0.3
      }} className="relative w-full max-w-lg bg-[#0a0a0a] border border-brand-gold/30 rounded-2xl shadow-[0_0_50px_rgba(201,168,76,0.15)] overflow-hidden z-10 flex flex-col max-h-[90vh]" data-id="element-170">
            {/* Header */}
            <div className="p-5 sm:p-6 border-b border-white/10 bg-gradient-to-b from-[#111] to-[#0a0a0a] flex justify-between items-center sticky top-0 z-20" data-id="element-171">
              <div data-id="element-172">
                <p className="text-gray-400 text-xs uppercase tracking-wider mb-1" data-id="element-173">
                  Estás llevando:
                </p>
                <h3 className="text-white font-bold text-lg sm:text-xl flex items-center gap-2" data-id="element-174">
                  {selectedPack === 'basic' ? '📘' : '🏆'} {packName}
                </h3>
              </div>
              <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors p-2 -mr-2" data-id="element-175">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-176">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-177" />
                </svg>
              </button>
            </div>

            {/* Content - Scrollable */}
            <div className="p-5 sm:p-6 overflow-y-auto" data-id="element-178">
              <div className="mb-6 text-center" data-id="element-179">
                <div className="inline-block bg-red-500/10 text-red-500 border border-red-500/20 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-180">
                  Oferta única antes de pagar
                </div>
                <h4 className="text-xl sm:text-2xl font-extrabold text-white mb-2 leading-tight" data-id="element-181">
                  ¿Querés sumar{' '}
                  <span className="text-brand-gold" data-id="element-182">El Arsenal Legal</span> a tu
                  pedido?
                </h4>
                <p className="text-gray-400 text-sm" data-id="element-183">
                  El complemento perfecto para asegurar tu éxito.
                </p>
              </div>

              {/* Bump Card */}
              <div onClick={() => setIsBumpSelected(!isBumpSelected)} className={`w-full rounded-xl p-4 sm:p-5 cursor-pointer transition-all duration-300 border-2 relative overflow-hidden ${isBumpSelected ? 'border-brand-gold bg-brand-gold/5 shadow-[0_0_20px_rgba(201,168,76,0.1)]' : 'border-gray-800 bg-[#111] hover:border-gray-600'}`} data-id="element-184">
                {/* Highlight banner if selected */}
                {isBumpSelected && <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-185" />}

                <div className="flex items-start gap-4" data-id="element-186">
                  <div className="shrink-0 mt-1" data-id="element-187">
                    <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-colors duration-200 ${isBumpSelected ? 'border-brand-gold bg-brand-gold' : 'border-gray-600 bg-transparent'}`} data-id="element-188">
                      {isBumpSelected && <svg className="w-4 h-4 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-189">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-190" />
                        </svg>}
                    </div>
                  </div>

                  <div className="flex-grow" data-id="element-191">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-2 mb-2" data-id="element-192">
                      <h5 className="font-bold text-white text-base sm:text-lg leading-tight" data-id="element-193">
                        Sí, quiero agregar El Arsenal Legal (PDF)
                      </h5>
                      <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-194">
                        <span className="text-brand-gold font-extrabold text-lg" data-id="element-195">
                          +$5.999
                        </span>
                      </div>
                    </div>

                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-196">
                      Modelos de escritos legales listos para usar, cartas
                      documento, y recursos adicionales para fortalecer tu caso
                      y acelerar el proceso.
                    </p>
                  </div>
                </div>
              </div>

              {/* Price Breakdown */}
              <div className="mt-6 bg-[#111] rounded-xl p-4 border border-white/5" data-id="element-197">
                <div className="flex justify-between text-sm text-gray-400 mb-2" data-id="element-198">
                  <span data-id="element-199">{packName}</span>
                  <span data-id="element-200">${packPrice.toLocaleString('es-AR')}</span>
                </div>
                {isBumpSelected && <div className="flex justify-between text-sm text-brand-gold mb-2" data-id="element-201">
                    <span data-id="element-202">El Arsenal Legal</span>
                    <span data-id="element-203">${bumpPrice.toLocaleString('es-AR')}</span>
                  </div>}
                <div className="h-px w-full bg-white/10 my-3" data-id="element-204" />
                <div className="flex justify-between items-center" data-id="element-205">
                  <span className="text-white font-bold" data-id="element-206">Total a pagar</span>
                  <span className="text-2xl font-extrabold text-white" data-id="element-207">
                    ${totalPrice.toLocaleString('es-AR')}
                  </span>
                </div>
              </div>
            </div>

            {/* Footer / Actions - Sticky Bottom */}
            <div className="p-5 sm:p-6 border-t border-white/10 bg-[#0a0a0a] sticky bottom-0 z-20" data-id="element-208">
              <a href={getCheckoutUrl()} target="_blank" rel="noopener noreferrer" className="w-full bg-green-500 hover:bg-green-600 text-black font-extrabold text-lg py-4 px-6 rounded-xl transition-all transform hover:scale-[1.02] shadow-[0_0_20px_rgba(34,197,94,0.2)] block text-center mb-4 uppercase tracking-wide" data-id="element-209">
                {isBumpSelected ? 'Comprar Pack + Arsenal Legal →' : 'Ir al checkout seguro →'}
              </a>

              <button onClick={() => {
            setIsBumpSelected(false);
            // Optional: auto-redirect if they click "continue without"
            // window.open(getCheckoutUrl(), '_blank')
          }} className={`w-full text-center text-sm transition-colors ${isBumpSelected ? 'text-gray-500 hover:text-white underline' : 'hidden'}`} data-id="element-210">
                No gracias, continuar solo con mi MegaPack
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}